import styled from 'styled-components';
import { Row, Col, Select, Button } from 'antd';
import { DEFAULT_RISK_RPN_COLOR } from '@/utils/constants';

export const Container = styled(Row)`
	padding: 20px 35px;
	border-radius: 18px;
	background-color: #ffffff;
`;

export const Title = styled(Col)`
	font-size: 1.3rem;
	.label {
		font-weight: 600;
		margin-right: 5px;
	}
`;

export const Score = styled(Col)`
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 1.3rem;
	font-weight: 600;
	border-radius: 6px;
	padding: 0.2% 2.2%;
	color: ${DEFAULT_RISK_RPN_COLOR};
	border: 2px solid ${DEFAULT_RISK_RPN_COLOR};
	background-color: #eaeefd;
`;

export const Content = styled(Col)`
	padding: 20px 30px;
	border-radius: 18px;
	background-color: #f8f8f8;
`;

export const InputsWrapper = styled(Col)`
	.ant-form-item {
		margin: 0;
	}
	.ant-input {
		border-radius: 6px !important;
		line-height: 1.8rem !important;
	}
	.ant-select-selector {
		border-radius: 6px !important;
		height: 2.4rem !important;
	}
	.ant-picker {
		width: 100%;
		border-radius: 6px !important;
		height: 2.4rem !important;
	}
`;

export const CustomSelect = styled(Select)`
	padding: 10px 12px;
`;

export const GenerateButton = styled(Button)`
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 1rem;
	border-radius: 6px;
	padding: 1rem 0.6rem;
	color: #ffffff;
	border: 1px solid ${DEFAULT_RISK_RPN_COLOR};
	background-color: ${DEFAULT_RISK_RPN_COLOR};
	box-shadow: 0px 2px 0px 0px #0000000b;
`;

export const SkeletonWrapper = styled(Col)`
	.ant-skeleton {
		width: 100% !important;
	}
`;
